/* global axios */
import CacheEnabledApiClient from './CacheEnabledApiClient';

class Inboxes extends CacheEnabledApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  // eslint-disable-next-line class-methods-use-this
  get cacheModelName() {
    return 'inbox';
  }

  getCampaigns(inboxId) {
    return axios.get(`${this.url}/${inboxId}/campaigns`);
  }

  deleteInboxAvatar(inboxId) {
    return axios.delete(`${this.url}/${inboxId}/avatar`);
  }

  getAgentBot(inboxId) {
    return axios.get(`${this.url}/${inboxId}/agent_bot`);
  }

  setAgentBot(inboxId, botId) {
    return axios.post(`${this.url}/${inboxId}/set_agent_bot`, {
      agent_bot: botId,
    });
  }

  syncTemplates(inboxId) {
    return axios.post(`${this.url}/${inboxId}/sync_templates`);
  }

  getInteractiveGreetingConfig(inboxId) {
    return axios.get(`${this.url}/${inboxId}/interactive_greeting_config`);
  }

  updateInteractiveGreetingConfig(inboxId, config) {
    return axios.post(
      `${this.url}/${inboxId}/update_interactive_greeting_config`,
      { config }
    );
  }

  sendTestInteractiveGreeting(inboxId, phoneNumber) {
    return axios.post(
      `${this.url}/${inboxId}/send_test_interactive_greeting`,
      { phone_number: phoneNumber }
    );
  }

  getInstagramAutoReplyConfig(inboxId) {
    return axios.get(`${this.url}/${inboxId}/instagram_auto_reply_config`);
  }

  updateInstagramAutoReplyConfig(inboxId, config) {
    return axios.post(
      `${this.url}/${inboxId}/update_instagram_auto_reply_config`,
      { config }
    );
  }

  createCSATTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/csat_template`, {
      template,
    });
  }

  getCSATTemplateStatus(inboxId) {
    return axios.get(`${this.url}/${inboxId}/csat_template`);
  }
}

export default new Inboxes();
